import { Component, OnInit, Input, Output, ViewChild, EventEmitter, ElementRef, AfterViewInit, Injectable, Inject } from '@angular/core';
import { ExternalUserService } from '@externaluserservice/external-user.service';
// import {InvoiceComponent} from '../invoice/invoice.component'
import { Routes, RouterModule, ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DomSanitizer, SafeResourceUrl, SafeHtml } from '@angular/platform-browser';
import { TransactionHistory, TransactionHistoryUpdate } from '@externalusermodel/Order';
import { ChaseUIDRequest } from '@externalusermodel/AdvancePayment';
import { ChaseProfileTransactionData } from '@externalusermodel/ChaseProfileTransactionData';

@Component({
    selector: 'app-invoice-details',
    templateUrl: './invoice-details.component.html',
    styleUrls: ['./invoice-details.component.css'],
    providers: [ExternalUserService],
    standalone: false
})
export class InvoiceDetailsComponent implements OnInit {


  totalamount: number;

  AmountpayingACH: string;
  AmountpayingCC: string;
  invoiceDetail: any = [];
  selectedInvoiceIDs: string;
  agencyID: string;
  isPayment: boolean;
  InvalidAmount: boolean;
  InvalidAmount2: boolean;
  actualAmount: number;
  isSelectedMultipleInovice: boolean;
  isChecked: boolean;
  displayAddRefundPopUp: boolean;
  UserID: any;
  ProfileDetail: any = [];
  response_data: string;
  methodName: string;
  count: any;
  chaseOrderId: string;
  private sub: any;
  uIDRequestData: ChaseUIDRequest;
  invoiceCount: number;
  isCreateNewProfileDisabled: boolean;
  isProfileSubmitDisabled: boolean;
  paymenttype: string;
  // 
  isCheckedAgency:boolean;

  selectedProfile: any;

  profileTransType: string;

  ShowACH: boolean;
  ShowCC: boolean;
//   For Partial validation change.
InvociegrossAmount: number;
  //Ajay - Button Disable
  isLoading: boolean = true;

  history: TransactionHistory[];

  constructor(private externalUserService: ExternalUserService, private route: ActivatedRoute,
    private _location: Location, private router: Router) {
    this.totalamount = 0;
    this.selectedInvoiceIDs = '';
    this.isPayment = true;
    this.displayAddRefundPopUp = false;
    this.ShowACH = false;
    this.ShowCC = false;
    this.isChecked = true;
  }
  ngOnInit() {


    this.ShowACH = true;
    this.ShowCC = false;
    //this.agencyID = sessionStorage.getItem('AgencyID');

    this.sub = this.route.params.subscribe(params => {
      this.chaseOrderId = params['chaseOrderId'];
      // debugger;
      this.externalUserService.getTransactionHistory(this.chaseOrderId)
        .subscribe(
        (p) => {
          // debugger;
          //let history: TransactionHistory[];
          this.history = p;
          this.invoiceCount = this.history.length;

          for (let hist of this.history) {
            this.totalamount += hist.totalAmount;
            this.selectedInvoiceIDs = this.selectedInvoiceIDs + hist.invoiceId + ', ';
          }

          this.actualAmount = this.totalamount;
          this.selectedInvoiceIDs = this.selectedInvoiceIDs.substr(0, this.selectedInvoiceIDs.length - 2);
          this.agencyID = this.history[0].agencyId.toString();
          // this.paymenttype = "Full";

          // to load page after user comes back from payment page
          if (this.history[0].isPartialPayment == true && this.history[0].transactionAmount != null) {
            // debugger;
            this.paymenttype = "Partial";
            this.totalamount = this.history[0].partialAmount;
            this.isChecked = false;
            this.isPayment = false;
          }
          else {
            this.paymenttype = "Full";
            this.isChecked = true;
            this.isPayment = true;
          }
          // ends here

          //debugger;
          this.externalUserService.GetInvoiceDetail(this.totalamount, this.agencyID, this.paymenttype, this.chaseOrderId, this.history).subscribe(
            (q) => {
              // debugger;
              //Ajay - Button Disable
              this.isLoading = false;

              this.invoiceDetail = q;
              this.AmountpayingACH = q['invTotalNetDiscountACH'].toString().replace(/,/g, '');
              this.AmountpayingCC = q['invTotalNetDiscountCC'].toString().replace(/,/g, '');


            }
          );

          if (this.invoiceCount > 1) {
            this.isSelectedMultipleInovice = true;
          } else {
            this.isSelectedMultipleInovice = false;
          }
        }
        );

    });

    this.InvalidAmount = false;
    this.InvalidAmount2 = false;

    if (this.invoiceCount > 1) {
      this.isSelectedMultipleInovice = true;
    } else {
      this.isSelectedMultipleInovice = false;
    }

    this.UserID = sessionStorage.getItem('userid');
  }

  GetInvoiceDetails() {
    //Ajay - Button Disable
    this.isLoading = true;
    this.externalUserService.GetInvoiceDetail(this.totalamount, this.agencyID, this.paymenttype, this.chaseOrderId, this.history).subscribe(
      p => {
        // debugger;
        //Ajay - Button Disable
        this.isLoading = false;

        this.invoiceDetail = p;

        this.AmountpayingACH = p['invTotalNetDiscountACH'].toString().replace(/,/g, '');
        this.AmountpayingCC = p['invTotalNetDiscountCC'].toString().replace(/,/g, '');

      },
    );


  }

  reCalculate(event, agencyID, paymenttype) {

    // this.actualAmount = event;
    // this.actualAmount = parseFloat((sessionStorage.getItem("totalamount").toString().replace(/,/g, '')));
    this.InvalidAmount = false;
    this.InvalidAmount2 = false;
    //  - changes if for partial payment validation. the valdation if for gross amount.
    this.InvociegrossAmount = this.actualAmount/.85;
    //if (Number(this.totalamount) >= this.actualAmount && this.isChecked === false) { // || Number(this.totalamount) <=0
    if (Number(this.totalamount) >= this.InvociegrossAmount && this.isChecked === false) { // || Number(this.totalamount) <=0
      this.InvalidAmount = true;
    } else if (Number(this.totalamount) <= 0) {
      this.InvalidAmount2 = true;
    } else {
      //Ajay - Button Disable
      this.isLoading = true;

      this.externalUserService.GetInvoiceDetail(this.totalamount, this.agencyID, this.paymenttype, this.chaseOrderId, this.history).subscribe(
        p => {
          //Ajay - Button Disable
          this.isLoading = false;

          this.invoiceDetail = p;
          this.AmountpayingACH = p['invTotalNetDiscountACH'].toString().replace(/,/g, '');
          this.AmountpayingCC = p['invTotalNetDiscountCC'].toString().replace(/,/g, '');

        });
    }


  }

  onChecked(event) {

    if (event.target.checked === false) {
      this.isPayment = false;
      this.InvalidAmount = false;

      this.isChecked = false;
      this.paymenttype = "Partial";
    } else {
      this.isChecked = true;
      this.isPayment = true;
      this.totalamount = this.actualAmount;
      this.paymenttype = "Full";
      // this.totalamount = parseFloat((sessionStorage.getItem("totalamount").toString().replace(/,/g, '')));
      // this.agencyID = sessionStorage.getItem("AgencyID");
      this.reCalculate(this.totalamount, this.agencyID, this.paymenttype);
      if (this.actualAmount >= +this.totalamount) {
        this.InvalidAmount = false;
      }
    }
  }
  // Method to go back
  goback() {

    this.router.navigate(['Invoice', 'invoice']);
  }


  Paynowprofile(value: any) {

    let requestData = new TransactionHistoryUpdate();
    requestData.chaseOrderId = this.chaseOrderId;
      //   for caputring ACH and CC net amount
   requestData.ordTotalNetDiscountACH = this.AmountpayingACH;
   requestData.ordTotalNetDiscountCC = this.AmountpayingCC;
    

    if (this.paymenttype === "Partial") {
      requestData.isPartialPayment = true;
      requestData.partialAmount = this.totalamount.toString();
    }

    else
      requestData.isPartialPayment = false;

    if (value === 1) {
      this.profileTransType = 'ACH';
      requestData.transactionAmount = this.AmountpayingACH;
    } else if (value === 2) {
      this.profileTransType = 'CC';
      requestData.transactionAmount = this.AmountpayingCC;
    }

    this.externalUserService.updateTransactionHistory(requestData).subscribe(
      response => {
        let status = response;

        if (status === 'Success') {
          this.router.navigate(['MediaPayPayment', 'Invoice', this.profileTransType, this.chaseOrderId]);
        }
      });
  }
  onRadioACHChecked(event) {
    if (event.target.checked == true) {
      this.ShowACH = true;
      this.ShowCC = false;

    }
  }

  onRadioCCChecked(event) {
    if (event.target.checked == true) {
      this.ShowCC = true;
      this.ShowACH = false;

    }
  }

}
